import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentListData } from '../types';
import { widgetDate } from './widgetFormat';

type Props = {
  data: DocumentListData;
};

const DocumentListWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  const { t } = useTranslation();
  if (data.items.length === 0) {
    return null;
  }
  return (
    <div className="ai-chat-widget ai-chat-widget-document-list">
      {data.items.map((item, idx) => (
        <div key={idx} className="ai-chat-widget-document-list-row">
          <div className="ai-chat-widget-document-list-main">
            <span className="ai-chat-widget-document-list-name">
              {item.name || '—'}
            </span>
            <span className="ai-chat-widget-document-list-meta">
              {[item.category, widgetDate(item.date, item.dateLabel)]
                .filter(Boolean)
                .join(' · ')}
            </span>
          </div>
          <a
            className="ai-chat-widget-document-list-view"
            href={item.viewUrl}
            target="_blank"
            rel="noreferrer">
            {t('aiChat.widgets.document.view')}
          </a>
        </div>
      ))}
    </div>
  );
};

export default DocumentListWidget;
